"use client";

import { canUseMerchantPermission } from "../api/client";
import { useMerchantShops } from "../store/use-merchant-shops";
import { useParams } from "@tanstack/react-router";
import type { ReactNode } from "react";

type RequireMerchantPermissionProps = {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
};

/** แสดง children ถ้า user มีสิทธิ์ในร้านปัจจุบัน และร้านมีระดับการยืนยันเพียงพอ (สอดคล้อง sidebar) */
export function RequireMerchantPermission({
  permission,
  children,
  fallback = null,
}: RequireMerchantPermissionProps) {
  const params = useParams({ strict: false });
  const shopId = params?.shopId as string | undefined;
  const { currentPermissions, currentShop } = useMerchantShops(shopId);
  const verifiedLevel = currentShop?.verifiedLevel ?? null;

  const canUse = canUseMerchantPermission(
    currentPermissions,
    permission,
    verifiedLevel,
  );

  if (!shopId || !canUse) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
}
